module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iR2DO"))).then(() => parcelRequire('f4eak'));